import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceExport\InvoiceExportUnpaid::__invoke
* @see app/Http/Controllers/InvoiceExport/InvoiceExportUnpaid.php
* @route '/api/invoice/export/unpaid-invoice'
*/
const InvoiceExportUnpaid = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: InvoiceExportUnpaid.url(options),
    method: 'post',
})

InvoiceExportUnpaid.definition = {
    methods: ["post"],
    url: '/api/invoice/export/unpaid-invoice',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\InvoiceExport\InvoiceExportUnpaid::__invoke
* @see app/Http/Controllers/InvoiceExport/InvoiceExportUnpaid.php
* @route '/api/invoice/export/unpaid-invoice'
*/
InvoiceExportUnpaid.url = (options?: RouteQueryOptions) => {
    return InvoiceExportUnpaid.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceExport\InvoiceExportUnpaid::__invoke
* @see app/Http/Controllers/InvoiceExport/InvoiceExportUnpaid.php
* @route '/api/invoice/export/unpaid-invoice'
*/
InvoiceExportUnpaid.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: InvoiceExportUnpaid.url(options),
    method: 'post',
})

export default InvoiceExportUnpaid